module.exports = __webpack_public_path__ + "img/forward-icon.a0ca483c.svg";